import { render, staticRenderFns } from "./GlobalErrorPopup.vue?vue&type=template&id=0655b8ea&scoped=true&"
import script from "./GlobalErrorPopup.vue?vue&type=script&lang=js&"
export * from "./GlobalErrorPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0655b8ea",
  null
  
)

export default component.exports